// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c-k9","toggleWrap":"styles_toggleWrap__31UIH","content":"styles_content__G9DcI","selectAreaCode":"styles_selectAreaCode__2mEOg"};